import Vue from 'vue';
import Vuex from 'vuex';
import { core } from 'modules/core/stores/core';
import { auth } from 'modules/auth/stores/auth';
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        version: '1.0.0',
    },
    modules: {
        core: core,
        auth: auth,
    },
});
//# sourceMappingURL=index.js.map